/**
 * @file String input type - extensible base for text-based inputs
 * @version 1.0.0
 */

export const StringInputType = {
  name: 'string',
  matches: getAttribute => getAttribute('type') === 'string',
  displayComponent: {
    name: 'StringDisplay',
    props: ['value', 'getAttribute'],
    computed: {
      formattedValue() {
        return this.formatDisplayValue(this.value);
      },
    },
    methods: {
      formatDisplayValue(value) {
        if (value === undefined || value === null) return '';
        return String(value);
      },
    },
    template: `<span>{{ formattedValue }}</span>`,
  },
  editComponent: {
    name: 'StringEdit',
    props: ['value', 'getAttribute', 'validationError'],
    emits: ['input', 'keydown', 'blur'],
    computed: {
      inputType() {
        return this.getInputType();
      },
      inputAttributes() {
        return this.getInputAttributes();
      },
    },
    methods: {
      getInputType() {
        return 'text';
      },
      getInputAttributes() {
        return {
          placeholder: this.getAttribute('description'),
          maxlength: this.getAttribute('maxLength'),
          min: this.getAttribute('minimum'),
          max: this.getAttribute('maximum'),
        };
      },
      parseInputValue(event) {
        return event.target.value;
      },
      handleInput(event) {
        const parsedValue = this.parseInputValue(event);
        this.$emit('input', { target: { value: parsedValue } });
      },
    },
    template: `
      <input
        :type="inputType"
        class="form-control form-control-sm"
        :class="{ 'is-invalid': validationError }"
        :value="value ?? ''"
        v-bind="inputAttributes"
        style="min-width: 150px"
        @input="handleInput"
        @keydown="$emit('keydown', $event)"
        @blur="$emit('blur', $event)"
      />
    `,
  },
};

export default StringInputType;
